module.exports = __webpack_public_path__ + "static/fowf-david-color-1a40f8804a211bb34096d6f30251f0a3.jpg";